import { Pill } from '@iwoca/orion';
import { useNumberFormat } from 'hooks/useNumberFormat';
import { TCommissionOverviewResponse } from 'lendingApi/lendingApi.types';
import { Tooltip } from 'react-tooltip';
import styles from './CommissionTooltip.module.css';

type TProps = {
  tooltipId: string;
  paidTo: string;
  dateRange: string;
  breakdown?:
    | TCommissionOverviewResponse['data']['introducer']
    | TCommissionOverviewResponse['data']['account'];
  hasError?: boolean;
};

const ERROR_MESSAGE =
  "Sorry, couldn't load commission right now. Refresh to try again.";

export const CommissionTooltip = ({
  tooltipId,
  paidTo,
  dateRange,
  breakdown,
  hasError = false,
}: TProps) => {
  const { formatCurrency } = useNumberFormat();

  return (
    <Tooltip
      className={styles.tooltip}
      id={tooltipId}
      opacity={1}
      openEvents={{ focus: false, mouseenter: true }}
      border="1px solid var(--color-structure-80)"
      place="bottom"
    >
      {hasError ? (
        ERROR_MESSAGE
      ) : (
        <div className={styles.content}>
          <span>
            Commission paid between
            <br />
            {dateRange}
            <br />
            {paidTo}
          </span>
          {breakdown && (
            <div className={styles.breakdown}>
              <div className={styles.breakdownRow}>
                <Pill variant="london" size="small">
                  Initial
                </Pill>
                {formatCurrency(breakdown.initial_commission)}
              </div>
              <div className={styles.breakdownRow}>
                <Pill variant="london" size="small">
                  Repeat
                </Pill>
                {formatCurrency(breakdown.repeat_commission)}
              </div>
            </div>
          )}
        </div>
      )}
    </Tooltip>
  );
};
